import {IEdits} from '../interfaces/reducers'
import {IPaylodAction} from '../interfaces/dispatchers'
import EditsActions from '../enums/ActionTypes/EditsActions'

const initState: IEdits = {edits: {}, originals: {}, localDbPendingChanges: {}}

let stateSnapShot: IEdits

const edits = (state: IEdits = initState, action: IPaylodAction): IEdits => {
  switch (action.type) {
    case EditsActions.ADD_OR_UPDATE_SOURCE_EDITS:
      stateSnapShot = {...state, edits: {...state.edits, ...action.payload}}
      return stateSnapShot
    case EditsActions.SET_SOURCE_EDITS:
      stateSnapShot = {...state, edits: {...action.payload}}
      return stateSnapShot

    case EditsActions.ADD_OR_UPDATE_SOURCE_ORIGINALS:
      stateSnapShot = {...state, originals: {...state.originals, ...action.payload}}
      return stateSnapShot
    case EditsActions.SET_SOURCE_ORIGINALS:
      stateSnapShot = {...state, originals: {...action.payload}}
      return stateSnapShot

    case EditsActions.ADD_OR_UPDATE_LOCALDB_PENDING:
      stateSnapShot = {...state, localDbPendingChanges: {...state.localDbPendingChanges, ...action.payload}}
      return stateSnapShot
    case EditsActions.SET_SOURCE_LOCALDB_PENDING:
      stateSnapShot = {...state, localDbPendingChanges: {...action.payload}}
      return stateSnapShot
    default:
      stateSnapShot = state
      return stateSnapShot
  }
}

;(window as any).gedits = () => {
  return stateSnapShot
}
export default edits
